import React from "react";
import RoundLoader from "../../../../components/ui/RoundLoader";
import ToolPrepUploadDropzone from "../../shared/Popup/ToolPrepUploadDropzone";
import "./DocumentFileSourceCard.css";

/**
 * Upload / selected-file identity for document watermark prep.
 * Replace / Remove live under Original | Preview (ToolPrepSourceCards).
 */
const DocumentFileSourceCard = ({
  fileName = null,
  fileSizeLabel = null,
  pageCount = 0,
  acceptLabel = "PDF",
  hint = "",
  kind = "pdf",
  loading = false,
  loadingLabel = "Loading preview…",
  error = null,
  onUploadClick = () => {},
  onFiles = null,
  disabled = false,
  uploadProgress = null,
  /** When true, meta is shown on ToolPrepSourceCards instead */
  hideFilledMeta = false,
}) => {
  if (uploadProgress != null) {
    return (
      <div className="dfs-card dfs-card--empty">
        <ToolPrepUploadDropzone
          kind={kind === "word" ? "word" : "pdf"}
          label={kind === "word" ? "Upload Word file" : `Upload ${acceptLabel}`}
          hint={
            hint ||
            (kind === "word"
              ? "Supported formats: DOC, DOCX"
              : "Supported formats: PDF")
          }
          progress={uploadProgress}
        />
      </div>
    );
  }

  if (!fileName) {
    return (
      <div className="dfs-card dfs-card--empty">
        <ToolPrepUploadDropzone
          kind={kind === "word" ? "word" : "pdf"}
          label={kind === "word" ? "Upload Word file" : `Upload ${acceptLabel}`}
          hint={
            hint ||
            (kind === "word"
              ? "Supported formats: DOC, DOCX"
              : "Supported formats: PDF")
          }
          onClick={onUploadClick}
          onFiles={onFiles}
          disabled={disabled}
        />
        {error ? <p className="dfs-card__error">{error}</p> : null}
      </div>
    );
  }

  if (hideFilledMeta) {
    if (loading || error) {
      return (
        <div className="dfs-card dfs-card--status">
          {loading ? (
            <div className="dfs-card__loading">
              <RoundLoader size="sm" label={loadingLabel} />
            </div>
          ) : null}
          {error ? <p className="dfs-card__error">{error}</p> : null}
        </div>
      );
    }
    return null;
  }

  return (
    <div className="dfs-card dfs-card--filled dfs-card--meta-only">
      <p className="dfs-card__meta-line" title={fileName}>
        <span className="dfs-card__meta-label">Uploaded file:</span>{" "}
        <span className="dfs-card__name">{fileName}</span>
      </p>
      {pageCount > 0 || fileSizeLabel ? (
        <span className="dfs-card__sub">
          {[
            fileSizeLabel,
            pageCount > 0
              ? `${pageCount} page${pageCount === 1 ? "" : "s"}`
              : null,
          ]
            .filter(Boolean)
            .join(" · ")}
        </span>
      ) : null}
      {loading ? (
        <div className="dfs-card__loading">
          <RoundLoader size="sm" label={loadingLabel} />
        </div>
      ) : null}
      {error ? <p className="dfs-card__error">{error}</p> : null}
    </div>
  );
};

export default DocumentFileSourceCard;
